<template>
  <div class="ProjectMemberItem">
    <div class="left">
      <div class="avatar">
        <van-image class="img" :src="item.avatar" fit="cover" round />
      </div>
      <div class="info">
        <div class="name text-ellipsis">{{item.name}}</div>
        <div class="tags">
          <div class="tag tag1" v-if="item.roleType === 1"><span>负责人</span></div>
          <div class="tag tag2" v-if="item.roleType === 3"><span>管理员</span></div>
          <div class="tag tag3" v-if="item.roleType === 2"><span>普通成员</span></div>
        </div>
      </div>
    </div>
    <div class="date">
      {{ item.joinTime  }}
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        @select="select($event, item)"
      >
        <template #reference>
          <van-button icon="ellipsis" type="" class="btn" v-if="item.roleType !== 1"></van-button>
        </template>
      </van-popover>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  name: 'TeamMemberItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    roleType: {
      type: Number,
      default: 3
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    showPopover (newValue) {
      const { item } = this;
      if (newValue) {
        // 自身是负责人
        if (this.roleType === 1) {
          if (item.roleType === 3) {
            this.actions = [{ text: '移除', type: 1 }, { text: '移除管理员', type: 3 }];
          } else if (item.roleType === 2) {
            this.actions = [{ text: '移除', type: 1 }, { text: '设为管理员', type: 2 }];
          }
        } else if (this.roleType === 2) {
          // 自身是负责人
          if (item.roleType === 3) {
            this.actions = [{ text: '移除', type: 1 }];
          }
        }
      }
    }
  },
  data () {
    return {
      showPopover: false,
      actions: []
    };
  },
  methods: {
    select ($event, item) {
      const { $utils } = this;
      const { type } = $event;
      let url = 'studio/delProjectMember';
      let message = '移除成功';
      if (type === 1) {
        Dialog.confirm({
          title: '提示',
          message: '您确定移除该项目成员吗？'
        })
          .then(() => {
            // on confirm
            this.$http
              .delete(`studio/delProjectMember?projectId=${this.id}&ids=${item.id}`)
              .then((res) => {
                $utils.successToast(message);
                this.$emit('refresh');
              });
          })
          .catch(() => {
            // on cancel
          });
      } else if (type === 2) {
        url = 'studio/setProjectAdmin';
        message = '设置成功';
        this.getAxios({ url, ids: [item.id], roleType: 3, message });
      } else if (type === 3) {
        url = 'studio/setProjectAdmin';
        message = '取消成功';
        this.getAxios({ url, ids: [item.id], roleType: 2, message });
      }
    },
    getAxios ({ url, ids, roleType, message }) {
      const { $utils } = this;
      this.$http
        .put(
          url,
          {
            projectId: this.id,
            ids,
            roleType
          },
          {
            showLoading: true
          }
        )
        .then((res) => {
          $utils.successToast(message);
          this.$emit('refresh');
        });
    }

  }
};
</script>

<style lang="less" scoped>
.ProjectMemberItem {
  margin: 0 auto 20px;
  padding: 30px 28px;
  width: 694px;
  height: 134px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    .avatar {
      width: 74px;
      height: 74px;
      margin-right: 20px;
      background-color: #fff;
      border-radius: 50%;
      box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      .img {
        width: 66px;
        height: 66px;
      }
    }
    .info {
      flex: 1;
      width: 0;

      .name {
        font-size: 28px;
        color: #333333;
      }
      .tags {
        display: flex;
        .tag {
          margin-top: 4px;
          min-width: 74px;
          height: 30px;
          border-radius: 4px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 10px;
          padding-right: 10px;
        }
        .tag1 {
          border: 1px solid #FF485D;
          color: #FF485D;
        }
        .tag2 {
          border: 1px solid #5BA7FF;
          color: #5BA7FF;
        }
        .tag3 {
          border: 1px solid #999AAA;
          color: #999AAA;
        }
      }
    }
  }
  .date {
    font-size: 24px;
    color: #999AAA;
    margin-left: 20px;
    display: flex;
    align-items: center;
    /deep/.btn{
      padding: 0;
      height: auto;
      padding: 10px 20px;
      &::before{
        background: transparent;
      }
    }
  }
}
</style>